import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";

export const FaqList = ({ items }) => {
    const [open, setOpen] = useState(0);
    return (
        <div data-testid="faq-list" className="divide-y divide-[#dddddd] border-y border-[#dddddd]">
            {items.map((item, i) => {
                const isOpen = open === i;
                return (
                    <div key={i} data-testid={`faq-item-${i}`}>
                        <button
                            onClick={() => setOpen(isOpen ? -1 : i)}
                            className="w-full text-left flex items-start justify-between gap-8 py-6 md:py-8 group"
                            data-testid={`faq-trigger-${i}`}
                            aria-expanded={isOpen}
                        >
                            <span className="font-serif text-2xl md:text-3xl text-[#111111] leading-tight max-w-3xl">
                                {item.q}
                            </span>
                            <span
                                className={`mt-2 shrink-0 transition-transform duration-500 ${
                                    isOpen ? "rotate-45" : "rotate-0"
                                }`}
                                aria-hidden
                            >
                                <Plus
                                    size={26}
                                    strokeWidth={1.25}
                                    className="text-[#111111]"
                                />
                            </span>
                        </button>
                        <AnimatePresence initial={false}>
                            {isOpen && (
                                <motion.div
                                    key="content"
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={{ height: "auto", opacity: 1 }}
                                    exit={{ height: 0, opacity: 0 }}
                                    transition={{
                                        duration: 0.5,
                                        ease: [0.16, 1, 0.3, 1],
                                    }}
                                    className="overflow-hidden"
                                >
                                    <div className="pb-8 pr-12 max-w-3xl text-[#444444] text-base md:text-lg leading-relaxed">
                                        {item.a}
                                    </div>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>
                );
            })}
        </div>
    );
};
